import { IMapEvents } from '../../interfaces/map-event.interface';

export const YandexMapEvents: IMapEvents = {
  click: 'click',
  dblclick: 'dblclick',
  rightclick: 'rightclick',
  contextmenu: 'contextmenu',
  mouseover: 'mouseover',
  mousedown: 'mousedown',
  mouseout: 'mouseout',
  mousemove: 'mousemove',
  mouseup: 'mouseup',
  drag: 'drag',
  actionbegin: 'actionbegin',
  boundschange: 'boundschange',
  mouseenter: 'mouseenter',
  mouseleave: 'mouseleave',
};
